import React, { Component } from 'react'
import SimpleTabs from '../components/Tabs/MarketTabPanel'

class MarketTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}

  export default MarketTab